import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { translateFormFieldLabel } from '../../../../../helpers/collaborativeIndexations'

class DefaultLabel extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        field: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object,
        ]),
    }

    constructor(props)
    {
        super(props)

        this.translateField = this.translateField.bind(this)
    }

    translateField(fieldName)
    {
        return translateFormFieldLabel(this.props.t, fieldName)
    }

    render()
    {
        const { field } = this.props

        return (
            <label title={this.translateField(field)}>{ this.translateField(field) }</label>
        )
    }
}

export default withTranslation()(DefaultLabel)
